<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-outbox`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 4v4H8v18h6a2 2 0 012 2v4h16v-4a2 2 0 012-2h6V8h-5V4h7a2 2 0 012 2v36a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h7zm-1 26H8v10h32V30h-4v4a2 2 0 01-2 2H14a2 2 0 01-2-2v-4zM25.898 4.414l7.778 7.778a1 1 0 010 1.415l-1.414 1.414a1 1 0 01-1.414 0l-4.417-4.417-.079 16.398a1 1 0 01-.996.995l-1.894.007a1 1 0 01-.996-.88L22.459 27l.079-16.397-4.418 4.419a1 1 0 01-1.415 0l-1.414-1.414a1 1 0 010-1.415l7.778-7.778a2 2 0 012.829 0z"/></svg>
</template>
<script>

export default {
  name: 'IconOutbox',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
